import React from 'react'
import { useIntl } from 'react-intl'
import { Button } from '../../../../components/Button'

export type MultiInviteButtonProps = {
	onClick: () => void
	disabled?: boolean
	numberSelected?: number
}

const MultiInviteButton = ({
	onClick,
	disabled,
	numberSelected,
}: MultiInviteButtonProps) => {
	const { formatMessage } = useIntl()
	return (
		<Button
			text={`${formatMessage({ id: 'global.invite' })}s ${numberSelected && numberSelected > 0 ? `(${numberSelected})` : ''}`}
			onClick={onClick}
			disabled={disabled}
		/>
	)
}

export default MultiInviteButton
